import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ["label"]
  static values = { tone: String, labelTu: String, labelVous: String }

  async toggle() {
    const newTone = this.toneValue === "tu" ? "vous" : "tu"

    const request = new FetchRequest('patch', '/users/ai_tone', {
      body: JSON.stringify({ ai_tone: newTone }),
      contentType: 'application/json'
    })
    const response = await request.perform()

    if (response.ok) {
      this.toneValue = newTone
      const newLabel = newTone === "tu" ? this.labelTuValue : this.labelVousValue

      // Update all tone switches on the page
      document.querySelectorAll('[data-controller="ai-tone"]').forEach(el => {
        el.dataset.aiToneToneValue = newTone
        const label = el.querySelector('[data-ai-tone-target="label"]')
        if (label) label.textContent = newLabel
        const checkbox = el.querySelector('input[type="checkbox"]')
        if (checkbox) checkbox.checked = newTone === "vous"
      })
    }
  }
}
